import { createTheme } from '@mui/material/styles';

// Creating a custom bright theme oriented for influencers
const theme = createTheme({
  palette: {
    primary: {
      main: '#5E35B1', // Bright purple - energetic, creative, luxury
      light: '#9162E4',
      dark: '#3B1F80',
      contrastText: '#fff',
    },
    secondary: {
      main: '#FF4081', // Bright pink - trendy, vibrant, stand-out
      light: '#FF79B0',
      dark: '#C60055',
      contrastText: '#fff',
    },
    background: {
      default: '#F9F9F9',
      paper: '#FFFFFF',
    },
    text: {
      primary: '#212121',
      secondary: '#757575',
    },
  },
  typography: {
    fontFamily: '"Montserrat", "Roboto", "Helvetica", "Arial", sans-serif',
    h1: {
      fontWeight: 700,
      fontSize: '3.5rem',
    },
    h2: {
      fontWeight: 600,
      fontSize: '2.5rem',
    },
    h3: {
      fontWeight: 600,
      fontSize: '2rem',
    },
    h4: {
      fontWeight: 600,
      fontSize: '1.5rem',
    },
    h5: {
      fontWeight: 500,
      fontSize: '1.25rem',
    },
    h6: {
      fontWeight: 500,
      fontSize: '1rem',
    },
    button: {
      textTransform: 'none',
      fontWeight: 600,
    },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 8,
          padding: '10px 24px',
          boxShadow: '0 4px 14px 0 rgba(94, 53, 177, 0.2)',
          transition: 'all 0.3s ease',
          '&:hover': {
            transform: 'translateY(-2px)',
            boxShadow: '0 6px 20px 0 rgba(94, 53, 177, 0.3)',
          },
        },
        contained: {
          '&:hover': {
            backgroundColor: '#7C4DFF',
          },
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          borderRadius: 16,
          boxShadow: '0 8px 40px rgba(0, 0, 0, 0.1)',
        },
      },
    },
  },
});

export default theme; 